module.exports = __webpack_public_path__ + "img/icontype8.c1941f16.png";